import React, { useState, useEffect } from 'react'
import axioInstance from '../components/axiosInstance'
import FinnLoader from '../components/FinnLoader'
import FinnModal from '../components/FinnModal'
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { apiUrl, Encryption } from '../components/global';

export default function RiskProfileView() {

    const [loading, setLoading] = useState(true);
    // eslint-disable-next-line
    const [riskProfileData, setRiskProfileData] = useState([]);
    const [showErrorModal, setShowErrorModal] = useState(false);
    // eslint-disable-next-line
    const [errorMessage, setErrorMessage] = useState("");
    const [errorTitle, setErrorTitle] = useState("Something went wrong");
    const [errorFooter, setErrorFooter] = useState();
    const [showButton, setShowButton] = useState(true);

    const [riskQna, setRiskQna] = useState([]);
    // eslint-disable-next-line
    const [fullname, setFullname] = useState();
    const [activeId, setActiveId] = useState();
    const [countdown, setCountdown] = useState(3); // Start countdown from 3
    // eslint-disable-next-line
    const [email, setEmail] = useState();
    useEffect(() => {
        document.body.classList.add('white_bg_fp_report');

        return function cleanup() {
            document.body.classList.remove('white_bg_fp_report');
        };
    }, []);

    const navigate = useNavigate();

    const openPdf = async (filename) => {
        const response = await fetch(`https://fpapi.finnovate.in/api/riskpdf/${filename}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
                'Accept': 'application/json'
            },
        });

        if (response.ok) {
            const blob = await response.blob();
            const fileURL = URL.createObjectURL(blob);
            window.open(fileURL, "_blank");
        } else {
            alert('Unauthorized or File not found');
        }
    };

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const profile_id = params.get("pid");

        const fetchData = async () => {

            try {
                //1. Validate Key & Profile ID
                const validateRes = await axioInstance.post(`admin/validate-key-id`, {
                    profile_id,
                });

                const token = validateRes.data.token;
                const key = validateRes.data.key;

                if (token !== '' && key !== '') {
                    sessionStorage.setItem('token', token);
                    try {

                        // 2. Fetch Profile Plan Report
                        const planRes = await axios.post(
                            `${apiUrl}profile/plan-fpreport`,
                            { profile_id: Encryption(key), req: "r" },
                            {
                                headers: {
                                    Authorization: token ? `Bearer ${token}` : "",
                                    "Content-Type": "application/json",
                                },
                            }
                        );

                        setEmail(planRes.data.email);
                        setFullname(planRes.data.full_name);

                        if (planRes.data.status === 100) {
                            const filteredRiskProfileData =
                                planRes.data.riskProfileData?.filter(
                                    (item) => item.add_source === "2" && item.risk_type >= 1
                                ) || [];

                            if (filteredRiskProfileData.length > 0) {
                                setRiskProfileData(filteredRiskProfileData);
                                const quest = filteredRiskProfileData[0]?.q_n_a
                                    ? JSON.parse(filteredRiskProfileData[0].q_n_a)
                                    : {};
                                setRiskQna(quest?.question || []);
                                setActiveId(filteredRiskProfileData[0].risk_id);
                            } else {
                                showError(
                                    "Risk Profile",
                                    <p>
                                        <strong className="text-danger font18">
                                            Your Investment Risk Profile is not yet created.
                                        </strong>
                                    </p>,
                                    <p>
                                        <a href={`risk-profile-link?email=${planRes.data.email}`}>
                                            Create Here
                                        </a>
                                    </p>
                                );
                            }
                        }

                    } catch (error) {
                        handleApiError(error);
                    } finally {
                        setLoading(false);
                    }
                }

            } catch (error) {
                handleApiError(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countdown, navigate]);

    const showError = (title, message, footer = null, showBtn = false) => {
        setErrorTitle(title);
        setErrorMessage(<div>{message}</div>);
        setErrorFooter(<div>{footer}</div>);
        setShowButton(showBtn); // decide if buttons should show
        setShowErrorModal(true);
    };

    // Error handling logic
    const handleApiError = (error) => {
        console.error("API Error:", error);

        if (error?.response?.status === 401 || error?.message === "Token has expired") {
            showError(
                "Session Expired!",
                <>
                    <strong className="text-danger">
                        Your session has expired. Please log in again.
                    </strong>
                    <br />
                    <small>
                        Redirecting to login page in{" "}
                        <span className="countdown">{countdown}</span> sec...
                    </small>
                </>
            );

            // Start countdown for redirect
            let interval = setInterval(() => {
                setCountdown((prev) => {
                    if (prev === 1) {
                        clearInterval(interval);
                        sessionStorage.clear();
                        navigate(sessionStorage.getItem("admin_id") ? "/ulogin" : "/sign-in");
                    }
                    return prev - 1;
                });
            }, 1000);
        } else if (error?.response?.status === 500) {
            showError(
                "Server Error",
                <p className="text-danger font18">
                    Something went wrong. Please try again later.
                </p>
            );
        } else if (error?.response?.status === 400) {
            showError(
                "Invalid Link",
                <p className="text-danger font18">
                    Invalid Link. Please try again with corrected Link.
                </p>
            );
        } else {
            showError(
                "Risk Profile",
                <p className="text-danger font18">
                    Something went wrong. Please try again.
                </p>
            );
        }
    };

    const displayQna = (q_n_a, risk_id) => {

        setLoading(true);

        const quest = q_n_a ? JSON.parse(q_n_a) : {};
        setRiskQna(quest?.question || []);
        setActiveId(risk_id);

        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }

    return (
        <>
            <div className="innercontainer mb40">
                <div className="mainwrapper">
                    {loading && <FinnLoader />}
                    <div className="planSection_wpr row">
                        <div className="col-12 pl90 pt25">

                            {
                                (riskProfileData.length > 0) && (
                                    <div id="RiskProfileSummary">
                                        <div className="tabContent_title font12 fw500 color7B8 pb15">
                                            <h1 className="font22 fw700 color0C4">{fullname}  (<small className="font16 fw700 color0C4">{email}</small>)</h1>
                                        </div>
                                        <div className="font18 fw700 color0C4 pt30">Risk Summary</div>
                                        {
                                            riskProfileData.length === 0 ? <p className='font14'>No Data</p> :
                                                (<>
                                                    {riskProfileData.map((history, key) => (
                                                        <div className="loanBox_outer mt25 p25" key={key}>
                                                            <div className="loandtl">
                                                                <div className="font13 fw500 color6d7">Risk Description</div>
                                                                <div className="font14 fw500 color182">{history.risk_description}</div>
                                                            </div>
                                                            <div className="loandtl">
                                                                <div className="font13 fw500 color6d7">Date</div>
                                                                <div className="font14 fw500 color182">{new Date(history.created).toLocaleDateString('en-GB')}</div>
                                                            </div>
                                                            <div className="loandtl">
                                                                <div className="font13 fw500 color6d7">PDF</div>
                                                                <div className="font14 fw500 color182">
                                                                    {/*history.ref_doc && (
                                                                        <a
                                                                            href={`https://planapi.finnovate.in/uploads/riskpdf/${history.ref_doc}`}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            className="color111"
                                                                        >
                                                                            <i className="fas fa-file-pdf fa-2x"></i>
                                                                        </a>
                                                                    )*/}
                                                                    {history.ref_doc && (
                                                                        <span
                                                                            onClick={() => openPdf(btoa(history.ref_doc))}
                                                                            target="_blank"
                                                                            rel="noreferrer"
                                                                            className="color111"
                                                                        >
                                                                            <i className="fas fa-file-pdf fa-2x"></i>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="loandtl">
                                                                <div className="font13 fw500 color6d7"></div>
                                                                <div className="font14 fw500 color182">

                                                                    {
                                                                        history.risk_id === activeId ? "Current" : (
                                                                            <>
                                                                                <i className="fas fa-eye fa-1x pointer" onClick={() => displayQna(history.q_n_a, history.risk_id)}></i>
                                                                            </>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>

                                                        </div>
                                                    ))}

                                                </>)
                                        }

                                        <div className="lineDevider mt40 mb40" />

                                        <div className="font22 fw700 color0C4">Risk Profile QNA</div>

                                        {riskQna.length === 0 ? (
                                            <tr>
                                                <td colSpan={4}>No Data</td>
                                            </tr>
                                        ) : (riskQna.map((item, index) => {
                                            return (
                                                <>

                                                    <div key={index}>
                                                        <label className="font16 fw600 color6d7 mt15">{item.label}</label>
                                                        <div className="row">
                                                            {item.answers.map((company, index) => {
                                                                return (
                                                                    <>
                                                                        <div className="col-12 col-sm-12">
                                                                            <div className="radio_btn">
                                                                                <label>
                                                                                    <input type="radio" name={item.key} value={company.ans_id} ques_id={item.ques_id} checked={company.ans_id === item.ans_value ? true : false} className='resetofgoal_box mr8' />
                                                                                    <span className='font13 fw500 color485'>{company.name}</span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                );
                                                            }
                                                            )}

                                                        </div>

                                                    </div>

                                                    <div className='mt15' />

                                                </>
                                            );
                                        }))}
                                    </div>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>

            <FinnModal
                show={showErrorModal}
                onClose={() => setShowErrorModal(false)}
                title={errorTitle}
                message={errorMessage}
                footer={errorFooter}
                isClosable={false} // Set to false if you don't want it to be closable
                isAction={showButton}
                primaryButtonText="Refresh"
                secondaryButtonText="Back to Dashboard"
                onPrimaryClick={() => {
                    setShowErrorModal(false);
                    window.location.reload();
                }}
                onSecondaryClick={() => window.location.href = 'dashboard'}
            />
        </>
    )
}
